import {pathname} from "../../../common/others/Configuration";
import Backbone from "backbone";

export default Backbone.Model.extend({
  url: function() {
    // TODO move to account configuration
    return [pathname, '/myaccount/api/v1/alerting/mail/interest/', this.get('id')].join('');
  },
  sync: function (method, model, options) {
    options.emulateHTTP = true;
    model.attributes = { id: model.attributes.id };
    return Backbone.sync(method, model, options);
  }
});
